export default __webpack_public_path__ + "static/media/photo 17.b765870c.jpg";